import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonWrapper = styled.div.withConfig({
  displayName: "PostmanButton__ButtonWrapper",
  componentId: "sc-1j0aqs0-0"
})(["float:right;"]);
function PostmanButton(props) {
  const {
    collectionId
  } = props;
  return /*#__PURE__*/_jsx(ButtonWrapper, {
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      href: `https://app.getpostman.com/run-collection/${collectionId}`,
      external: true,
      children: "Run in Postman"
    })
  });
}
export default PostmanButton;